var _defs, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _rect, _path7, _rect2, _polygon2, _path8, _path9, _path10, _path11, _path12, _path13, _rect3, _rect4, _rect5, _rect6, _rect7, _path14, _path15, _rect8, _rect9, _rect10, _path16, _path17, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _polygon3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _polygon4, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g, _ellipse3, _rect27, _path66, _polygon5, _polygon6, _polygon7, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _polygon8, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _polygon9, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _polygon10, _path114, _path115, _path116;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 1105.04,
    height: 782.74,
    viewBox: "0 0 1105.04 782.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac3cc305-f6db-42f4-bbbd-32121ee27a74-34",
    x1: 403.57,
    y1: 833.5,
    x2: 403.57,
    y2: 218.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad14f186-b27f-416c-b629-0bafa2f1236e-35",
    x1: 940.67,
    y1: 825.72,
    x2: 940.67,
    y2: 263.72,
    xlinkHref: "#ac3cc305-f6db-42f4-bbbd-32121ee27a74-34"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "medicine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.38,
    cy: 766.65,
    rx: 97.44,
    ry: 15.65,
    fill: "#2696be",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 897.05,
    cy: 767.09,
    rx: 121.59,
    ry: 15.65,
    fill: "#2696be",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.08,396.83H162.57V535.16H68.51c-.25,1.42-.49,2.85-.75,4.28h94.81V651c-.17-.05-.32-.11-.48-.17-2.68-1.06-5.34-2.18-8-3.38l-1.7-.77q-4-1.89-8-4c-.93-.49-1.86-1-2.78-1.52A166.42,166.42,0,0,1,101.73,610c-.34-.33-.66-.68-1-1-1.62-1.76-3.21-3.54-4.75-5.36l-1.7-2c-1.82-2.23-3.58-4.52-5.29-6.84-.25-.34-.49-.68-.75-1a148.88,148.88,0,0,1-17.2-31.1c-.14-.33-.26-.69-.39-1Q68.59,556.4,67,551c-.46-1.51-.9-3-1.28-4.57-.14-.46-.26-.91-.37-1.36C59.67,522.9,59,499.87,59,477c0-2.67,0-5.35,0-8,0-9.25.11-18.56.27-27.86,0-2.41.1-4.81.15-7.23q.21-9.21.6-18.42c.06-1.71.14-3.41.23-5.11q0-1.47.15-2.94C60.64,403.88,60.84,400.35,61.08,396.83Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.57,242.81H106.9a422,422,0,0,1,29.61-40.76c8.27-10.16,17-20.06,26.06-29.6Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.57,247.09V392.55H61.4c0-.42.07-.85.1-1.27.09-1.15.18-2.3.28-3.44.11-1.34.23-2.69.36-4s.27-2.91.42-4.36.29-2.92.46-4.37.32-2.9.5-4.34.34-2.9.53-4.34c.15-1.2.31-2.39.47-3.59.23-1.69.47-3.39.73-5.07,0-.25.07-.51.11-.75a345.9,345.9,0,0,1,7.45-36.52,270.08,270.08,0,0,1,12.55-37,277.75,277.75,0,0,1,18.88-36.36Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.8,396.82V535.16H403.57V396.82Zm0,142.61v118.8c1.24.26,2.47.51,3.69.72,1.66.32,3.31.61,5,.86.32.05.65.1,1,.13.66.11,1.34.2,2,.29,1.67.23,3.33.42,5,.57.79.08,1.59.15,2.39.21l1.93.15h0c1.05.08,2.09.14,3.12.17.64,0,1.28.06,1.94.08.5,0,1,0,1.52,0s1.26,0,1.89,0c.86,0,1.72,0,2.57,0H220c.86,0,1.72,0,2.57-.08h.06c.59,0,1.19,0,1.79-.08a4.19,4.19,0,0,0,.5,0c.5,0,1,0,1.48-.07l.35,0,3.35-.26c1.1-.1,2.21-.23,3.33-.35l2.28-.27a199.45,199.45,0,0,0,27.45-5.84c20.22-5.64,40-13.53,60.21-19.31,26.13-7.45,55-11.11,80.25-2V539.43ZM403.57,242.81V58.64a278.67,278.67,0,0,0-70.43,8.26C278.25,80.69,229,110.6,186.8,148.8v94h10.88v4.27H186.8V392.55H403.57V247.08H242.35v-4.27ZM682,180.6c-13.58-.48-27.08-4.78-39.29-11.42-23.35-12.7-42-32.31-62.84-48.86-43.3-34.47-97-55.27-152.09-60.43V242.81H737.23L738,242Zm28.19-5,29.89,32.8V167C730.07,168.24,721.3,171.19,710.23,175.56Zm29.89,512.13V539.43H676.39c-.17-.63-.34-1.27-.54-1.91.19.64.35,1.28.53,1.91H427.82V646.68c2.36,1.75,4.69,3.59,7,5.46h0c2.49,2,4.95,4.11,7.42,6.18l2.49,2.06c1.19,1,2.39,2,3.6,2.94q3.6,2.92,7.27,5.76c1.21,1,2.45,1.9,3.68,2.84a501.22,501.22,0,0,0,61.63,40.31q7.23,4,14.59,7.81c3.27,1.67,6.56,3.33,9.86,4.94q7.44,3.63,15,7h0a550.84,550.84,0,0,0,146,42.53q16.79,2.48,33.71,3.9V687.72l1,0ZM427.82,247.08V392.55h312.3V247.08Zm0,149.74V535.16h312.3V396.82Zm336.54-230V213l38.15-41.86Q783.55,168.08,764.36,166.77Zm0,230.05V535.16h303.75V396.82ZM1067,698.71l1.07-159.28H764.36V780a544.73,544.73,0,0,0,58.7-.7h0l.34,0q14-.88,27.87-2.56l.21,0a513.24,513.24,0,0,0,143.2-38.21m132-318.93c-1.14-2.69-2.33-5.36-3.54-8-2.26-5-4.65-9.86-7.11-14.72h-23.7V535.16h59.92C1152.22,496,1142.31,456,1126.71,419.55Zm-34.35,119.88v137c16.88-16.18,31.14-34.69,41.41-55.85,12.35-25.48,18-53.07,18.46-81.17Zm0-182.92v36h21.48A390,390,0,0,0,1092.36,356.51Zm-206-162.6c-1.58-.6-3.16-1.21-4.75-1.8a433.62,433.62,0,0,0-51.31-15.42l-58.38,64.07h0L770.77,242l.75.82H979.3A444.41,444.41,0,0,0,886.36,193.91Zm99.06,53.17H768.62l-4.26,3.9V392.55H801.7l.06,0,0,0h266.39V324A432.8,432.8,0,0,0,985.42,247.08Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.57,320.46v72.09H61.4c0-.42.07-.85.1-1.27.09-1.15.18-2.3.28-3.44.11-1.34.23-2.69.36-4s.27-2.91.42-4.36.29-2.92.46-4.37.32-2.9.5-4.34.34-2.9.53-4.34c.15-1.2.31-2.39.47-3.59.23-1.69.47-3.39.73-5.07,0-.25.07-.51.11-.75a345.9,345.9,0,0,1,7.45-36.52Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.08,396.83H162.57V535.16H68.51c-.25,1.42-.49,2.85-.75,4.28h94.81V651c-.17-.05-.32-.11-.48-.17-2.68-1.06-5.34-2.18-8-3.38l-1.7-.77q-4-1.89-8-4c-.93-.49-1.86-1-2.78-1.52A166.42,166.42,0,0,1,101.73,610c-.34-.33-.66-.68-1-1-1.62-1.76-3.21-3.54-4.75-5.36l-1.7-2c-1.82-2.23-3.58-4.52-5.29-6.84-.25-.34-.49-.68-.75-1a148.88,148.88,0,0,1-17.2-31.1c-.14-.33-.26-.69-.39-1Q68.59,556.4,67,551c-.46-1.51-.9-3-1.28-4.57-.14-.46-.26-.91-.37-1.36C59.67,522.9,59,499.87,59,477c0-2.67,0-5.35,0-8,0-9.25.11-18.56.27-27.86,0-2.41.1-4.81.15-7.23q.21-9.21.6-18.42c.06-1.71.14-3.41.23-5.11q0-1.47.15-2.94C60.64,403.88,60.84,400.35,61.08,396.83Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "215.87 209.28 215.87 333.92 139.56 333.92 139.56 209.28 150.44 209.28 150.44 167.08 195.1 167.08 195.1 209.28 215.87 209.28",
    fill: "#2696be",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 139.57,
    y: 338.19,
    width: 76.3,
    height: 138.33,
    fill: "#2696be",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.8,539.44h76.31v115a199.11,199.11,0,0,1-27.45,5.83l-2.28.28c-1.12.13-2.23.24-3.33.35s-2.24.19-3.35.26l-.35,0c-.48,0-1,.06-1.47.07l-.51,0c-.6,0-1.2.06-1.8.08h0c-.85.05-1.7.06-2.57.07-.37,0-.72,0-1.09,0-.86,0-1.71,0-2.57,0l-1.89,0c-.51,0-1,0-1.53,0l-1.93-.07c-1,0-2.08-.11-3.12-.18h0l-1.92-.14-2.39-.22c-1.68-.15-3.35-.34-5-.57l-2-.28-1-.14c-1.67-.26-3.32-.54-5-.86-1.23-.21-2.45-.47-3.69-.72Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 629.96,
    y: 194.56,
    width: 62.92,
    height: 139.35,
    fill: "#2696be",
    opacity: 0.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "692.89 338.19 692.89 476.53 380.58 476.53 380.58 416.86 546.93 416.86 546.93 452.06 629.96 452.06 629.96 338.19 692.89 338.19",
    fill: "#2696be",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M741.12,687.76l-1,0v90.75q-16.9-1.43-33.7-3.89A550.87,550.87,0,0,1,560.36,732q-20.13-9.06-39.44-19.78a503.26,503.26,0,0,1-61.64-40.31q-7.36-5.64-14.53-11.54c-3.31-2.73-6.6-5.53-9.93-8.25-2.31-1.87-4.64-3.71-7-5.47V539.44H676.37c-.17-.64-.34-1.28-.52-1.91.19.63.37,1.27.54,1.91h63.73V687.7C740.46,687.71,740.79,687.74,741.12,687.76Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M904.22,242.81h-41V230.07H881.6V192.12q2.39.87,4.76,1.79v36.16h17.86Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1003,392.55H801.72s0,0,.07.05l-.09-.05H764.36V253.2h10.58v103h48.35v-61h39.94V247.09h41v48.15h39.94v61H1003Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M764.36,396.82V535.16H1003V396.82ZM1067.78,698l.33-109.5H1003v-49H764.36V780a544.73,544.73,0,0,0,58.7-.7h0l.34,0q14-.88,27.87-2.56l.21,0a513.24,513.24,0,0,0,143.2-38.21",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.57,539.44h55.67c-.49,28.09-6.13,55.68-18.47,81.16-10.27,21.17-24.54,39.68-41.4,55.85v-88h4.2Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.27,535.16h-55.7V419.55h30.14C1142.31,456,1152.22,496,1152.27,535.16Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 659.18,
    y: 233.3,
    width: 33.71,
    height: 43.69,
    fill: "#2696be",
    opacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 659.18,
    y: 323.86,
    width: 33.71,
    height: 10.06,
    fill: "#2696be",
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 659.18,
    y: 338.19,
    width: 33.71,
    height: 29.35,
    fill: "#2696be",
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 659.18,
    y: 414.42,
    width: 33.71,
    height: 43.69,
    fill: "#2696be",
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 659.18,
    y: 504.98,
    width: 33.71,
    height: 43.69,
    fill: "#2696be",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M740.12,687.7c.34,0,.67,0,1,.06l-1,0v10.15h-33.7V654.17h33.7Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M740.12,744.71v33.75q-16.9-1.43-33.7-3.89V744.71Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 380.58,
    y: 473.32,
    width: 144.47,
    height: 3.21,
    fill: "#2696be",
    opacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 380.58,
    y: 480.8,
    width: 144.47,
    height: 12.3,
    fill: "#2696be",
    opacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 380.58,
    y: 533.42,
    width: 144.47,
    height: 19.78,
    fill: "#2696be",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M572.28,652.15v19.78h-113q-7.36-5.62-14.54-11.54c-3.31-2.73-6.59-5.53-9.93-8.24Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M572.28,712.24V732H560.35q-20.11-9.07-39.43-19.79Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 775.83,
    y: 351.6,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 160.05,
    y: 219.09,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 160.05,
    y: 285.15,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 160.05,
    y: 351.21,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 160.05,
    y: 417.26,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 160.05,
    y: 483.32,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 160.05,
    y: 549.38,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 884.4,
    y: 351.6,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 775.83,
    y: 421.75,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 884.4,
    y: 421.75,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 775.83,
    y: 491.89,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 884.4,
    y: 491.89,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 775.83,
    y: 562.04,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 884.4,
    y: 562.04,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 775.83,
    y: 632.19,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 884.4,
    y: 632.19,
    width: 28.44,
    height: 28.44,
    fill: "#2696be",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "775.83 720.67 775.83 702.33 804.26 702.33 804.26 718.06 775.83 720.67",
    fill: "#2696be",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.24,357v16.27h97.33V357Zm9.7,15.25H67V358h8Zm9.69,0h-8V358h8Zm9.67,0h-8V358h8Zm9.69,0H96V358h8Zm9.68,0h-8V358h8Zm9.69,0h-8V358h8Zm9.69,0h-8V358h8Zm9.68,0h-8V358h8Zm9.68,0h-8V358h8Zm9.68,0h-8V358h8Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.24,404.34v16.27h97.33V404.34Zm9.7,15.24H67V405.37h8Zm9.69,0h-8V405.37h8Zm9.67,0h-8V405.37h8Zm9.69,0H96V405.37h8Zm9.68,0h-8V405.37h8Zm9.69,0h-8V405.37h8Zm9.69,0h-8V405.37h8Zm9.68,0h-8V405.37h8Zm9.68,0h-8V405.37h8Zm9.68,0h-8V405.37h8Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.24,451.7V468h97.33V451.7Zm9.7,15.24H67V452.72h8Zm9.69,0h-8V452.72h8Zm9.67,0h-8V452.72h8Zm9.69,0H96V452.72h8Zm9.68,0h-8V452.72h8Zm9.69,0h-8V452.72h8Zm9.69,0h-8V452.72h8Zm9.68,0h-8V452.72h8Zm9.68,0h-8V452.72h8Zm9.68,0h-8V452.72h8Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.24,499.06v16.25h97.33V499.06Zm9.7,15.24H67V500.07h8Zm9.69,0h-8V500.07h8Zm9.67,0h-8V500.07h8Zm9.69,0H96V500.07h8Zm9.68,0h-8V500.07h8Zm9.69,0h-8V500.07h8Zm9.69,0h-8V500.07h8Zm9.68,0h-8V500.07h8Zm9.68,0h-8V500.07h8Zm9.68,0h-8V500.07h8Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.66,546.41c.39,1.53.83,3.06,1.29,4.57v-3.55h8v14.22H70.67c.13.33.26.69.39,1h91.51V546.41Zm19,15.24h-8V547.43h8Zm9.67,0h-8V547.43h8Zm9.69,0H96V547.43h8Zm9.68,0h-8V547.43h8Zm9.69,0h-8V547.43h8Zm9.69,0h-8V547.43h8Zm9.68,0h-8V547.43h8Zm9.68,0h-8V547.43h8Zm9.68,0h-8V547.43h8Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.26,593.77c.25.32.49.68.75,1H94.3v6.83c.57.68,1.13,1.36,1.71,2v-8.87h8V609h-3.24c.32.33.63.68,1,1h60.83V593.77ZM113.67,609h-8V594.79h8Zm9.69,0h-8V594.79h8Zm9.69,0h-8V594.79h8Zm9.68,0h-8V594.79h8Zm9.68,0h-8V594.79h8Zm9.68,0h-8V594.79h8Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M141.65,641.12c.91.52,1.84,1,2.78,1.52v-.5h8v4.5l1.7.79v-5.29h8v8.65a2.5,2.5,0,0,0,.48.18v-9.85Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M801.72,392.55h0l.06,0Zm-61.6,295.14v0l1,0ZM675.85,537.52c.19.64.35,1.28.53,1.91h0C676.22,538.8,676.05,538.16,675.85,537.52Zm125.87-145h0l.06,0Zm-604-149.74v4.27h44.67v-4.27ZM740.12,687.69v0l1,0ZM675.85,537.52c.19.64.35,1.28.53,1.91h0C676.22,538.8,676.05,538.16,675.85,537.52Zm125.87-145h0l.06,0Zm-61.6,295.14v0l1,0ZM675.85,537.52c.19.64.35,1.28.53,1.91h0C676.22,538.8,676.05,538.16,675.85,537.52Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M508.84,438.3s-3.94-.55-3.94-6.29-2.82-16.46-2.82-16.46h0c0-.05-2.44-18.67-5.81-21.63s-7.7-20.34-7.7-20.34-.74-9.43-2.25-11.46-3.55-7-6.56-14.09-15.56-12-15.56-12-22.69-13.16-29.12-17.45h0a9.86,9.86,0,0,1-1.63-1.23c-1.12-1.47-6-1.5-6-1.5-.51-3.22-1-6.92-1.16-10.27,0-.36,0-.72-.05-1.08a34.6,34.6,0,0,0,15.21-18.82c.12-.38.22-.78.33-1.16a3.25,3.25,0,0,0,1.95-1.76c.58-1.29.59-2.8,1.31-4,.84-1.42,2.44-2.18,3.7-3.25,3.18-2.7,4-7.25,3.85-11.39-.1-3.35-.64-6.73-.43-10.06l.06-.84c.06-.5.13-1,.22-1.48.49-2.48,1.56-4.82,2.16-7.28s.66-5.23-.74-7.35c-2.05-3.11-6.32-3.73-10.07-4.05-4.25-.36-8.05.11-10.77-3.42a38.39,38.39,0,0,0-4.28-5.17c-.56-.52-6-3.84-6-4.06a24.31,24.31,0,0,0-16.95-1.3c-2.82.82-5.48,2.16-8.34,2.83-6.17,1.46-13.27-.12-18.51,3.41-2.92,2-4.67,5.18-6.31,8.28q-2,3.83-4.06,7.65c-2.21,4.19-4.46,8.45-5.39,13.09a20.78,20.78,0,0,0-.36,3.06h0v.05c0,.37,0,.74,0,1.11v.47c0,.35,0,.69.06,1s.05.41.08.62.08.68.14,1,.18.88.3,1.32c.05.19.12.37.18.55.1.34.22.67.35,1,.07.17.14.35.22.52.15.35.33.69.51,1,.08.14.14.27.22.4a13.27,13.27,0,0,0,.92,1.34c2.14,2.67,5.29,4.37,7.62,6.87,0,.1,0,.2,0,.29,0,.28,0,.55,0,.83A34.23,34.23,0,0,0,389,303.75c0,.38.05.77.07,1.15a57.22,57.22,0,0,1-.11,8.91,4.2,4.2,0,0,0-3.32-1.48,4.79,4.79,0,0,0-1.28.11l-.09-.07h0v.09c-2.2.54-4.91,2.83-7.5,9.34,0,0-7.88,8.88-13.88,8.51s-21.19,9.24-21.19,9.24-14.82,9.62-18,19.42a136.86,136.86,0,0,1-6.38,16.28L299,413h0l-3.38,29.95s1.87,13.32,1.5,15.35,7.69,20.34,7.69,20.34,26.63,46.79,37.51,49.19l.78-.55a6.38,6.38,0,0,0,1.47.55l2.24-1.58a24.41,24.41,0,0,1-.17,5.28c-1.5,4.62.56,34.77,3.18,40.68s1.69,83.4,1.69,83.4l-.37,6.84s0,.22.09.6l-.09,1.62.27.14a19.26,19.26,0,0,1-.27,6.51c-.94,3-1.32,11.48-1.32,11.48s-7.49,47.88-3.94,57.5,6.57,20.16,6.57,20.16,3.75,12,.18,14.05S338.91,780,341,785c1.9,4.62,9.11,17,10.18,18.81l-.09.95-1.47,15.93a20,20,0,0,0,1.69,6.08c1.61,3.47,4.74,7.07,10.69,6.68,1-.07,2.16-.19,3.28-.34,10.89-1.46,24.3-6.32,24.3-6.32a9.91,9.91,0,0,1-1.9-1.57h0a5.49,5.49,0,0,1-1.67-4c.16-2.9-5.27-16.72-6.62-20.12-.21-.49-.32-.77-.32-.77s12.38-12.94,10.32-24.41c0,0-13.7-8-9.19-12.39s12.57-17,12.57-17,.37-47.15,0-54.19a58.3,58.3,0,0,1,.69-14.63c.15-.73.33-1.44.52-2.14A130.55,130.55,0,0,0,412.82,677c2.3,0,4.64,0,7-.14q0,1,.09,2.16c.52,11.68,1.49,32.16,2.28,39.77,1.12,10.91,7.31,40.31,7.31,40.31s-11.81,7.58,2.06,26.26c0,0,0,6.77-.92,7.75l0,0a84.78,84.78,0,0,0-2.37,9.76c-.58,3.52-.82,7.08.12,8.93,2.25,4.42,15.75,4.06,15.75,4.06h0l.33-.06a19.35,19.35,0,0,1,14.29,4.31c5.13,4.12,24.6,2.31,35.14,1,4.13-.52,6.89-1,6.89-1a4,4,0,0,0,.14-1.44h0c-.11-2.59-2.14-8.27-15.9-13.34,0,0-12.94-8.7-12.76-16.28H472l-1.5,0c1.09-.06,1.79,0,1.79,0s-5.07-18.5-3-20-4.13-22-4.13-22-3.55-34.4-3.74-36.81a21,21,0,0,1,.93-6.1l-.93-18.86s-.18-6.27,0-8.31a41.5,41.5,0,0,0-.43-5.29c-.09-.7-.18-1.43-.28-2.15,4.85-1.23,8-2.37,8-2.37l-.56-65.65c4.12-8,4.88-25.55,4.86-38,0-8-.36-13.92-.36-13.92l5.63-9.19s1.3-11-.76-13.41c-.91-1.09-.5-2.22.25-3.15A10.46,10.46,0,0,1,479,523s-.06-.09-.13-.22a9.94,9.94,0,0,1,1.25-.89s-2-3.1-.21-4.41c1.68,1.14,3.18,2,4.32,2.7-.08.73-.16,1.15-.16,1.15l.48-1c1.1.62,1.77,1,1.77,1s8.82-17.57,8.63-20.16,6-13.5,6-13.5.75-5.73,4.13-8.13,2.62-19.79,2.62-19.79.94-9.06,3.19-12.76S508.84,438.3,508.84,438.3Zm-168.76-7.71.17,4.19c-1-1.61-1.72-2.77-1.72-2.77Z",
    transform: "translate(-47.24 -58.63)",
    fill: "url(#ac3cc305-f6db-42f4-bbbd-32121ee27a74-34)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M486.8,513.74l-2.16,9.2s-17.3-8.83-20.42-20.05,5.22-15.48,5.22-15.48l16.12,6.83Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M486.8,513.74l-2.16,9.2s-17.3-8.83-20.42-20.05,5.22-15.48,5.22-15.48l16.12,6.83Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M389.71,826.85s-16,5.88-27,6.62c-5.84.39-8.91-3.19-10.49-6.64a20.1,20.1,0,0,1-1.65-6.05L352,804.93l.76-8.44,23.37-6.07,3.31,10.12.31.77c1.33,3.38,6.66,17.13,6.5,20a5.46,5.46,0,0,0,1.64,3.95A9.51,9.51,0,0,0,389.71,826.85Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M499,818.79a4,4,0,0,1-.14,1.43s-34.22,5.71-41.22,0A18.54,18.54,0,0,0,443.24,816s-13.24.36-15.45-4c-.92-1.83-.68-5.38-.11-8.88a84.59,84.59,0,0,1,2.32-9.71l.53-.42,3.15-2.53,36.88-1.09h.28c-.18,7.54,12.52,16.19,12.52,16.19C496.85,810.56,498.84,816.21,499,818.79Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M499,818.79a4.08,4.08,0,0,1-.15,1.43s-34.21,5.71-41.21,0A18.54,18.54,0,0,0,443.25,816s-13.25.36-15.45-4c-.92-1.84-.69-5.38-.12-8.88,5.1.51,13.15,1.78,16.31,4.81,4.78,4.61,12.88,9.21,17.85,9.57C465.73,817.75,489,818.49,499,818.79Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M389.71,826.85s-16,5.88-27,6.62c-5.84.39-8.91-3.19-10.48-6.65,4.07,1.37,9.72,2.81,12.69,1.49,3.52-1.56,16-2.57,23-3A9.85,9.85,0,0,0,389.71,826.85Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M413.45,353c-13.2-5.13-30.18-22.08-25.94-30a17.72,17.72,0,0,0,1.65-6.36,58.07,58.07,0,0,0,.12-9A123.25,123.25,0,0,0,387.51,293s41.21.93,38.81,7c-.7,1.78-.81,4.87-.62,8.33s.69,7.37,1.21,10.68c.72,4.54,1.44,8,1.44,8s-2.52,3.53-4,3.72S432.39,360.31,413.45,353Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#cf6f80"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M379.72,801.31l-.31.34c-12.32-14.9-27.22,3.67-27.22,3.67l-.22-.39.76-8.44,23.37-6.07,3.31,10.12Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M470.85,790.42s-9-.19-13.8,4.05-28,.92-27,0a3.29,3.29,0,0,0,.52-1.52l3.15-2.53,36.88-1.09C470.74,790,470.85,790.42,470.85,790.42Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M395.05,673.41a27.82,27.82,0,0,0-1.52,5.13,58.71,58.71,0,0,0-.69,14.56c.37,7,0,53.91,0,53.91s-7.91,12.51-12.32,16.92,9,12.33,9,12.33c2,11.4-10.12,24.28-10.12,24.28-12.32-14.9-27.22,3.68-27.22,3.68s-8.1-14-10.12-19,7.91-8.46,11.4-10.49-.17-14-.17-14-2.95-10.49-6.45-20.06,3.86-57.21,3.86-57.21.38-8.46,1.29-11.41a19.08,19.08,0,0,0,.27-6.48c-.06-.73-.13-1.34-.18-1.75s-.09-.6-.09-.6l.14-.24,5-9.32S397.45,667.54,395.05,673.41Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M470.85,789.32s-9-.19-13.8,4-28,.92-27,0,.92-7.73.92-7.73c-13.61-18.58-2-26.12-2-26.12s-6.08-29.25-7.18-40.1c-.77-7.58-1.72-27.95-2.23-39.58-.22-5-.35-8.44-.35-8.44l11.12-2.24,1.43-.29,26.82-5.38s.74,5,1.24,9.09a42.48,42.48,0,0,1,.42,5.27c-.18,2,0,8.26,0,8.26l.91,18.77a21.32,21.32,0,0,0-.91,6.07c.18,2.39,3.67,36.61,3.67,36.61s6.07,20.42,4,21.89S470.85,789.32,470.85,789.32Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M426.32,300c-.7,1.78-.81,4.87-.62,8.33a34.25,34.25,0,0,1-36.42-.68A123.25,123.25,0,0,0,387.51,293S428.72,293.91,426.32,300Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M442.25,277.9a33.87,33.87,0,0,1-1.68,10.61,34.22,34.22,0,0,1-66.74-9.79c0-.28,0-.54,0-.82a34.22,34.22,0,1,1,68.43,0Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#cf6f80"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M413.45,353c-13.2-5.13-30.18-22.08-25.94-30a17.72,17.72,0,0,0,1.65-6.36l18.07,14.85,11.18,9.17,8.5-21.64c.72,4.54,1.44,8,1.44,8s-2.52,3.53-4,3.72S432.39,360.31,413.45,353Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "412.94 360 397.85 613.5 378.17 614.79 327.21 467.8 335.57 293.29 337.33 256.42 359.99 275.03 371.18 284.2 379.93 261.93 396.2 276.11 412.94 360",
    fill: "#2696be"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M395.05,673.41a27.82,27.82,0,0,0-1.52,5.13,145,145,0,0,1-41.26-12.89l-.27-.14.09-1.61.05-.84,5-9.32S397.45,667.54,395.05,673.41Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M430.56,678.58a101.24,101.24,0,0,1-11.06,1.26c-.22-5-.35-8.44-.35-8.44l11.12-2.24Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M459.76,672.58c-7.11,1.85-18.09,3.93-27.92,2.63l-.14-6.34,26.82-5.38S459.26,668.44,459.76,672.58Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M431.66,676.37c-41,7-78.55-13.07-78.55-13.07l.36-6.8s.93-77.09-1.65-83-4.59-35.88-3.13-40.48-5.33-73.58-5.33-73.58l-1.1-28L302,415.13l18-37.52a135.39,135.39,0,0,0,6.26-16.2c3.13-9.74,17.66-19.31,17.66-19.31s14.9-9.56,20.79-9.2,13.61-8.46,13.61-8.46c5.7-14.53,10.86-7.95,10.86-7.95,0,.69,0,0-.28,2.15-2,15.95,32.34,66.35,32.83,67.24h0L425,465.54l3.31,100.81Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M430.56,676.37c-41,7-78.56-13.07-78.56-13.07l.37-6.8s.93-77.09-1.66-83-4.59-35.88-3.12-40.48-5.33-73.58-5.33-73.58l-1.11-28-40.28-16.37,18-37.52a137.51,137.51,0,0,0,6.26-16.2c3.12-9.74,17.66-19.31,17.66-19.31s14.9-9.56,20.78-9.2,13.61-8.46,13.61-8.46c5.71-14.53,12-7.95,12-7.95,0,.69-.6,1-.28,2.15,4.4,15.47,31.24,66.35,31.73,67.24h0l3.31,79.66,3.31,100.81Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M419.51,388.09c-4.41-1.84-27.77-28.51-27.77-28.51v-6.07c-.85-2-5.9-.78-10,.62l1.76-36.87,2,1.66C389.88,334.38,419,387.2,419.51,388.09Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M420.62,385.88c-4.42-1.84-27.78-28.51-27.78-28.51V351.3c-.85-2-5.9-.78-10,.62l1.77-36.87,2,1.66C391,332.17,420.13,385,420.62,385.88Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M353.11,518.89c.55,0,28.51-2.94,28.51-2.94s16.93,33.29,15.82,41.39-3.12,15.27-9.93,14-36.65,1-36.65,1Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M352,516.68c.55,0,28.51-2.94,28.51-2.94s16.92,33.3,15.82,41.39-3.13,15.27-9.93,14-36.65,1-36.65,1Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M373.07,501.05s25.66,13.79,26.21,18-13.06-1.84-16-2.57a36.61,36.61,0,0,0-5.89-.92l-19.61.53Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#cf6f80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 365.11,
    cy: 328.48,
    r: 2.7,
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.11,
    cy: 327.38,
    r: 2.7,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.08,
    cy: 445.36,
    r: 2.7,
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.08,
    cy: 444.25,
    r: 2.7,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.8,
    cy: 386.92,
    r: 2.7,
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.8,
    cy: 385.82,
    r: 2.7,
    fill: "#3f3d56"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M477.28,515s1.84,2.76,0,4.05.18,4.41.18,4.41-4.59,2.69-2.57,5.11.74,13.35.74,13.35l-5.52,9.14s.33,5.89.35,13.85c0,12.42-.73,29.88-4.77,37.84l.56,65.31s-19.33,7.06-35.51,4.91l-2.4-104.8s3.5-59.43,4.79-70.83a118.68,118.68,0,0,0,.92-17.85s-.55-17.84-2.4-26.12c0,0-2-35.87-2.2-45.8-.09-4.75.16-18.61.44-31.79.31-14.41.66-28,.66-28l-3.65-28.88s3.65-.37,4.75,1.1a10.53,10.53,0,0,0,1.6,1.23h0c6.3,4.26,28.56,17.36,28.56,17.36s12.32,4.9,15.27,11.92,5,12,6.43,14,2.21,11.4,2.21,11.4,4.24,17.3,7.55,20.23S499,417.71,499,417.71l-29.25,23s-2.57,38.26-3.12,39.74S477.28,515,477.28,515Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M478.39,515s1.83,2.76,0,4.05.17,4.41.17,4.41S474,526.18,476,528.6s.74,13.35.74,13.35l-5.52,9.14s.33,5.89.36,13.85c0,12.42-.73,29.88-4.77,37.84l.55,65.31S448,675.15,431.84,673l-2.39-104.8s3.5-59.43,4.79-70.83a117.58,117.58,0,0,0,.91-17.85s-.55-17.84-2.39-26.12c0,0-2-35.87-2.21-45.8-.09-4.75.17-18.61.44-31.79.31-14.41.66-28,.66-28l-4.82-29.27s4.82,0,5.93,1.49a9.49,9.49,0,0,0,1.6,1.23h0c6.3,4.26,28.57,17.36,28.57,17.36s12.31,4.9,15.26,11.92,5,12,6.44,14,2.2,11.4,2.2,11.4,4.24,17.3,7.55,20.23,5.7,21.53,5.7,21.53l-29.25,23s-2.57,38.26-3.13,39.74S478.39,515,478.39,515Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M443.36,356.3,446,364,432.1,378c.31-14.4.66-28,.66-28l-4.82-29.27s4.82,0,5.93,1.49a9.12,9.12,0,0,0,1.6,1.22h0l11.82,34.1Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M442.25,354.09l2.65,7.7-13.9,14c.31-14.41.66-28,.66-28l-4.83-29.27s4.83,0,5.93,1.49a10,10,0,0,0,1.6,1.23h0l11.83,34.09Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M442.25,277.9a33.87,33.87,0,0,1-1.68,10.61,1.43,1.43,0,0,1-1.08-.27c-.26-9-4.69-17.45-10.14-24.64a25.89,25.89,0,0,0-5.5-5.7,10.76,10.76,0,0,0-7.46-2.11c-3,.41-5.65,2.45-8.68,2.71-4,.33-7.58-2.44-11.55-2.58a11.35,11.35,0,0,0-8.49,3.94,23.29,23.29,0,0,0-4.55,8.44,49.38,49.38,0,0,0-2.54,14.56c-.05,2.8-.32,6.31-2.92,7.33a14.94,14.94,0,0,0-3.77-11.41l-.06-.06c0-.28,0-.54,0-.82a34.22,34.22,0,1,1,68.43,0Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M422.21,223.57a23.56,23.56,0,0,0-16.62-1.3c-2.77.82-5.38,2.15-8.19,2.82-6,1.45-13-.12-18.15,3.39-2.86,2-4.58,5.16-6.18,8.23l-4,7.62c-2.18,4.17-4.38,8.41-5.29,13s-.36,9.73,2.55,13.42c2.12,2.69,5.25,4.38,7.55,6.91a15,15,0,0,1,3.76,11.4c2.61-1,2.86-4.52,2.92-7.32a49.38,49.38,0,0,1,2.54-14.56,23.21,23.21,0,0,1,4.55-8.44,11.37,11.37,0,0,1,8.49-3.94c4,.14,7.59,2.9,11.55,2.57,3-.25,5.66-2.3,8.68-2.7a10.72,10.72,0,0,1,7.46,2.11,25.62,25.62,0,0,1,5.49,5.7c5.46,7.19,9.89,15.62,10.15,24.64,1.13.83,2.76-.25,3.32-1.53s.58-2.78,1.29-4c.82-1.41,2.39-2.16,3.62-3.22,3.12-2.69,3.9-7.22,3.78-11.33s-.92-8.28-.14-12.32c.47-2.48,1.53-4.8,2.11-7.25s.65-5.2-.72-7.31c-2-3.1-6.21-3.71-9.88-4-4.17-.36-7.9.1-10.56-3.41a38.3,38.3,0,0,0-4.2-5.14C427.56,227.09,422.21,223.79,422.21,223.57Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#512e4e"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M313.52,434.45l-10.45-19.32-3.31,29.81s1.84,13.24,1.47,15.27,7.54,20.23,7.54,20.23,26.13,46.54,36.8,48.94l36.05-25.76-9.56-12.14s-3.31-1.29-4.14,0c0,0-17.75-30.54-19.59-32.75s-1.48-6.62-1.48-6.62-2.76-2.94-1.84-5.7-5.33-12.33-5.33-12.33l5.7-5.33Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M303.62,412.93l-2.76,2.2-3.31,29.81s1.84,13.24,1.47,15.27,7.55,20.23,7.55,20.23,26.12,46.54,36.79,48.94l36.06-25.76-9.57-12.14s-3.31-1.29-4.14,0c0,0-17.75-30.54-19.59-32.75s-1.47-6.62-1.47-6.62-2.76-2.94-1.84-5.7-5.34-12.33-5.34-12.33l5.7-5.33Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M474.89,529.71c2,2.43.74,13.34.74,13.34l-5.52,9.14s.33,5.9.35,13.85l-9.28,2.9a5.51,5.51,0,0,1-7.15-5.43l1.6-51.61,21.65,8.28c-1.84,1.28.18,4.42.18,4.42S472.87,527.28,474.89,529.71Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M476,528.6c2,2.43.74,13.35.74,13.35l-5.52,9.14s.33,5.89.36,13.85l-9.45,2.95a5.4,5.4,0,0,1-7-5.32l1.61-51.77,21.66,8.28c-1.85,1.28.17,4.41.17,4.41S474,526.18,476,528.6Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M483.17,504s-1.47,9.39-5.15,9.94-5.33,15.19-9,14.67-1.24-13.61-1.11-16.15-4-13.06-.91-15.45,12.87,0,12.87,0Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#cf6f80"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M491,431.69l6.94-14s2.76,10.67,2.76,16.37,3.86,6.26,3.86,6.26,4.23,5,2,8.64-3.13,12.7-3.13,12.7.73,17.29-2.58,19.68-4,8.1-4,8.1-6.08,10.85-5.89,13.43-8.46,20.05-8.46,20.05,4.23-21.71-20.42-31.09c0,0-.19-7.37,1.65-9.39s4.71-2.94,2.91-13.15-.52-22.41-.52-24.86,5.52-17.73,5.52-17.73Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M494,415.69l6.06,2s2.77,10.67,2.77,16.37,3.86,6.26,3.86,6.26,4.23,5,2,8.64-3.12,12.7-3.12,12.7.73,17.29-2.58,19.68-4.05,8.1-4.05,8.1-6.07,10.85-5.88,13.43-8.47,20.05-8.47,20.05,4.24-21.71-20.42-31.09c0,0-.18-7.37,1.66-9.39s4.71-2.94,2.91-13.15-.52-22.41-.52-24.86,5.52-17.73,5.52-17.73Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M360.15,778.56s9.66-6.07,16-1.66S360.15,778.56,360.15,778.56Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M435.21,759.79s8.55-1.1,15.73,6.63S435.21,759.79,435.21,759.79Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.72,276.18c-1.23,1.06-2.81,1.82-3.63,3.23-.7,1.21-.72,2.7-1.28,4s-2.19,2.36-3.32,1.54c-.26-9-4.7-17.45-10.15-24.65a25.62,25.62,0,0,0-5.49-5.7,10.75,10.75,0,0,0-7.47-2.11c-3,.41-5.64,2.45-8.67,2.7-4,.34-7.59-2.43-11.56-2.57a11.32,11.32,0,0,0-8.48,3.95,23.16,23.16,0,0,0-4.55,8.43,49.44,49.44,0,0,0-2.54,14.56c-.06,2.79-.32,6.27-2.9,7.31a13.7,13.7,0,0,1,0,2.22c2.6-1,2.86-4.52,2.92-7.32a49.38,49.38,0,0,1,2.54-14.56,23.21,23.21,0,0,1,4.55-8.44,11.35,11.35,0,0,1,8.48-3.94c4,.14,7.6,2.9,11.56,2.57,3-.25,5.66-2.3,8.67-2.7a10.75,10.75,0,0,1,7.47,2.11,25.62,25.62,0,0,1,5.49,5.7c5.45,7.19,9.89,15.62,10.15,24.64,1.13.83,2.76-.25,3.32-1.53s.58-2.78,1.28-4c.82-1.41,2.4-2.16,3.63-3.22,3.12-2.69,3.9-7.22,3.78-11.33,0-.13,0-.26,0-.38C451.33,270.25,450.38,273.88,447.72,276.18Z",
    transform: "translate(-47.24 -58.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.9,275.47c-2.3-2.53-5.44-4.22-7.55-6.9a14.64,14.64,0,0,1-2.91-8.19,15.4,15.4,0,0,0,2.91,10.39c2.11,2.69,5.25,4.38,7.55,6.91a15,15,0,0,1,3.77,8.92A15,15,0,0,0,373.9,275.47Z",
    transform: "translate(-47.24 -58.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.47,245.28c-.59,2.45-1.64,4.78-2.12,7.25a23.1,23.1,0,0,0-.31,5,19.42,19.42,0,0,1,.31-2.84c.48-2.48,1.53-4.8,2.12-7.25a12.3,12.3,0,0,0,.33-4.14A13.9,13.9,0,0,1,453.47,245.28Z",
    transform: "translate(-47.24 -58.63)"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.73,
    cy: 744.94,
    rx: 97.44,
    ry: 15.65,
    fill: "#2696be",
    opacity: 0.1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 129.6,
    y: 445.14,
    width: 6.27,
    height: 141.17,
    fill: "#535461"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M222.51,644.51l-.39,6.36-.56,9-.23,3.74-.55,9-.24,3.74-.56,9-6.32,102.07a17.3,17.3,0,0,1-17.26,16.22H163.54a17.29,17.29,0,0,1-17.25-16.22L140,685.28l-.56-9-.23-3.74-.56-9-.23-3.74-.56-9-.4-6.36a9,9,0,0,1,9-9.51h67.21A8.94,8.94,0,0,1,222.51,644.51Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.88 592.24 174.32 601.21 91.14 601.21 90.58 592.24 174.88 592.24",
    fill: "#9d9cb5"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.09 604.95 173.54 613.93 91.93 613.93 91.37 604.95 174.09 604.95",
    fill: "#9d9cb5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "173.3 617.68 172.75 626.65 92.72 626.65 92.16 617.68 173.3 617.68",
    fill: "#9d9cb5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M128.25,556.68C164.76,583.1,180,624.42,180,624.42s-44-1.51-80.52-27.93-51.73-67.73-51.73-67.73S91.73,530.26,128.25,556.68Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M47.72,528.76s45.68,25.35,60.33,46.34S180,624.42,180,624.42",
    transform: "translate(-47.24 -58.63)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M151.82,503.46C171.69,517.83,180,540.32,180,540.32s-23.95-.82-43.83-15.19S108,488.26,108,488.26,131.94,489.08,151.82,503.46Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M108,488.26s24.86,13.8,32.83,25.22S180,540.32,180,540.32",
    transform: "translate(-47.24 -58.63)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M208.85,539.18c-22.83,25.09-27.66,57.88-27.66,57.88s32.19-7.9,55-33,27.66-57.88,27.66-57.88S231.68,514.09,208.85,539.18Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M263.87,506.19s-29.74,25.72-37.3,43.44-45.38,47.43-45.38,47.43",
    transform: "translate(-47.24 -58.63)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.91,530.35s-16.51-82.14-10.19-92.36c0,0,.23-9.5-.15-21.61,0-.46,0-.92,0-1.39a30.76,30.76,0,0,0,3.47,2,28.08,28.08,0,0,0,18.9,2.44l-5-5.57c-1.2-1.33-2.45-2.77-2.71-4.53s.46-3.33,1.08-4.9c4.75-12,5-27.09-4.15-36.25-7.73-7.7-9.61-17.64-18-24.67-6.13-5.15-9.5-12.7-12.68-20-2.69-6.17-5.4-12.39-6.94-18.93-1.2-5.11-1.68-10.4-3.33-15.39s-4.74-9.84-9.57-12.07c-1.72-.79-3.63-1.24-5.2-2.29-2.06-1.39-3.3-3.65-4.79-5.63-7.57-10-32.92-4.11-44.92-.05a25.27,25.27,0,0,0-8.88,4.92l.11-.18c.09-.15.2-.3.3-.45a15.78,15.78,0,0,0-3.36,3.75c-1.75,2.77-2.48,6-3.94,9-1.76,3.55-11.55,13.46-7.34,17.45a3.55,3.55,0,0,0,1,.64,8.65,8.65,0,0,0,5,.5l-.18.43a29.23,29.23,0,0,0-2.17,11.09c0,16.43,13.55,29.75,30.28,29.75a30.57,30.57,0,0,0,9.27-1.43c.07.38.13.76.2,1.14,0,.15.05.3.07.45v0l-.53.74a1,1,0,0,0-.09-.13l-15.7,21.94c-2.4,1.69-16.22,11.69-17,19.19-.82,8.21-1.64,17.82-1.64,17.82l-.11,2.06a6.18,6.18,0,0,1-5,1.35c-4.9-.8-4.9,18-4.9,18s-3.26,3-5.5.4-8.16,6.21-8.16,6.21l-37.1,1.6h0l-.85.05-2-6.19a2.61,2.61,0,0,0-3.27-1.67,3,3,0,0,0-.45.19l-.14.08-.26.18-.13.12a2,2,0,0,0-.2.21l-.12.14-.06.06h0a2.52,2.52,0,0,0-.36,2.24l1.72,5.31c-7.16,1.44-14.48,5.5-8.51,16.68l-30.26-5.59,9.79,8.22,50.54,10.43c-.67,1.2-.23,2.94,1.86,5.39,9,10.57,25.4,13.44,32,14.18a56.81,56.81,0,0,0,6.49,11l-.57,10.53s-16.71,80.26-19.77,84.33a47.57,47.57,0,0,0,4.23-5.57c-4.85,16.49-11.63,39.06-13.41,42.44-2.86,5.4-5.51,27.25-2.25,28.65,1,.43,3.86.22,7.94-.09v1.81l-.18,68.59s.82,42.07-1.43,46.08-2.85,12.42-2.85,12.42-9,16.59-16.13,23.26a1.07,1.07,0,0,1-.16.14l-.22-1.56s-8.57,10.82-27.53,10.21c0,0-11.41,7.42,5.51,7.82s38.53-.6,38.53-.6,15.09-23,27.73-20v17.43h3.87V804.6a15.87,15.87,0,0,0,6.89-10.43,12.68,12.68,0,0,0-4.52-11.73,7.5,7.5,0,0,1-2.47-5.48l-.14.12c0-.35-.09-.71-.13-1.08-1.11-9-2.5-27.57,2.41-41.31,6.73-18.84,8.77-45.08,3.87-60.7a139.56,139.56,0,0,1-3.89-15.21c-.12-.65-.23-1.27-.33-1.85a78.85,78.85,0,0,1,9.93,2c11.35,3.13,36.18,3.71,57.38,3.54.05.58.11,1.19.18,1.8A65.5,65.5,0,0,0,998,676.79c2.66,8,3.88,43.27,3.88,43.27s3.43,29,1.56,40.8c-1,6.56-2,13.15-2.57,19.77v.13s-5.62,16-9.73,24.69c-.1.22-.21.44-.31.65a13,13,0,0,0-3.21.71s-5.51,11-11,12.82-3.67,7.81,8.76,5.61,31.2-4,31.2-4l.81-11.22,3.82-4.78-1,11.19,4.07-.8-.54-13.61,6.25-7.82s7.55-6.72-3.67-19.94v.29c-.12-.19-.23-.39-.36-.58l0-.06c-1.86-2.88-3.34-8.25-.63-17.78,4.9-17.22,7.75-32.85,7.75-32.85s10.94-41.87-2.21-61.68l.58,0a33.32,33.32,0,0,1-2.83-8.8q-.1-.54-.18-1.11c9.73-.56,19.28-2.32,27.07-6.12C1055.48,645.53,1050.79,546.17,1046.91,530.35Zm-123.53-69.3v.2l-2,.1Zm-6.86.95a2.21,2.21,0,0,0-.9.43,8.88,8.88,0,0,0-1.57,4.11l-3.12-.7s-2.19-.47-5.34-1l-1.49-1.5C908.2,463,912.46,462.5,916.52,462Z",
    transform: "translate(-47.24 -58.63)",
    fill: "url(#ad14f186-b27f-416c-b629-0bafa2f1236e-35)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "972.51 743.53 971.32 757.7 975.31 756.9 974.71 741.53 972.51 743.53",
    fill: "#1d2366"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M928.72,734.88c-4.81,13.7-3.45,32.19-2.37,41.17.4,3.32.77,5.34.77,5.34s-7.19,16.38-7.79,17-21.16,13.17-21.16,13.17l-14.37,8.39s-14.58-6.39-7.59-8.59a10.61,10.61,0,0,0,3.77-2.57c7-6.65,15.79-23.18,15.79-23.18s.6-8.39,2.8-12.38,1.4-45.92,1.4-45.92l.17-68.35,0-8.91,27.35.2a61.89,61.89,0,0,0,1.18,9,137.59,137.59,0,0,0,3.81,15.16C937.3,690,935.3,716.11,928.72,734.88Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#ffb0b1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M927.12,781.39s-7.19,16.38-7.79,17-21.16,13.17-21.16,13.17l-14.37,8.39s-14.58-6.39-7.59-8.59a10.61,10.61,0,0,0,3.77-2.57l.62,4.37,4.79-.2,41-36.89C926.75,779.37,927.12,781.39,927.12,781.39Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M926.62,777l-41.23,37.14-4.79.2-1-7s-8.38,10.78-27,10.18c0,0-11.18,7.39,5.39,7.79s37.73-.6,37.73-.6,14.78-23,27.15-20v17.37h3.8V804.55a15.79,15.79,0,0,0,6.74-10.4A12.74,12.74,0,0,0,929,782.47,7.53,7.53,0,0,1,926.62,777Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#1d2366"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.55,756.24c-2.66,9.5-1.21,14.85.61,17.72l0,.06a32.75,32.75,0,0,1,4.78,11.67l.16.9-18.76,27.35-10.18,4s-16.37-5.59-13.38-7.19c.75-.39,1.92-2.47,3.26-5.34,4-8.65,9.52-24.61,9.52-24.61v-.13c.58-6.59,1.5-13.16,2.52-19.7,1.83-11.77-1.53-40.66-1.53-40.66s-1.2-35.13-3.8-43.12a65.93,65.93,0,0,1-2.33-12.44c-.54-5-.66-9.12-.66-9.12s10.78-15,30.54,1.2a21.74,21.74,0,0,1,4.13,4.48c13.65,19.42,2.66,62.2,2.66,62.2S1028.34,739.07,1023.55,756.24Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#ffb0b1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.13,786.59l-18.76,27.35-10.18,4s-16.37-5.59-13.38-7.19c.75-.39,1.92-2.47,3.26-5.34,6.93-.06,10.52,6.54,10.52,6.54l8.78-1.4s11.58-22.76,14.18-24.15.4-10.39.4-10.39v-2.29c.07.08.13.17.21.25l0,.06a32.75,32.75,0,0,1,4.78,11.67Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.19,812.54s-5-9.18-14.58-5.79c0,0-5.39,11-10.78,12.78s-3.59,7.78,8.59,5.59,30.54-4,30.54-4l.8-11.19,12.38-15.77s7.38-6.69-3.6-19.86v2.29s2.2,9-.4,10.39S1010,811.14,1010,811.14Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#1d2366"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M927.52,650.23a61.89,61.89,0,0,0,1.18,9c-11.26-1.65-21.71-.83-28.56-.29l0-8.91Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.54,663.8s-16,.78-35.08.94c-.54-5-.66-9.12-.66-9.12s10.78-15,30.54,1.2a21.74,21.74,0,0,1,4.13,4.48A24.4,24.4,0,0,0,1029.54,663.8Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.54,662s-70.08,3.39-91.44-2.6-42.53-.8-45.72-2.19-.6-23.16,2.2-28.55,18.16-59.9,18.16-59.9l14.78-77.06,15.57-4.29,1.1-.31,27.13-7.48,19.88-5.49s39.53,154.33,36.14,165.71a29.14,29.14,0,0,0-.58,13.39A33.42,33.42,0,0,0,1029.54,662Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#1d2366"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M876,439s-14,15-3.4,23.36,17.57.8,17.57.8Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#c7daf5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M876,439s-14,15-3.4,23.36,17.57.8,17.57.8Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M989.11,340.38s-1.64,1.56-4.11,3.86c-3.52,3.29-8.73,8.1-13.35,12.13-6.4,5.57-11.68,9.66-9.79,6.17s1.53-9.57.59-15.26c-.07-.38-.13-.76-.2-1.13a104.8,104.8,0,0,0-3.09-12.36s10.34-13.36,16.06-18.63c2.13-2,3.62-2.82,3.71-1.43.1,1.87,1.5,6,3.24,10.38.05.14.1.27.16.41,1.16,3,2.47,6.08,3.62,8.74C987.71,337.34,989.11,340.38,989.11,340.38Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#ffb0b1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M982.33,324.52a29.68,29.68,0,0,1-19.88,22.76,104.07,104.07,0,0,0-3.29-13.49s19.47-25.15,19.77-20.06C979,315.66,980.52,319.94,982.33,324.52Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M960.51,354l2.52-3.55s1.67,10.18,7.81,5.69,6.44,33.79,6.44,33.79l-6.59,98.53-47.62-2.85L924.42,438l5.39-24,13.33-34.89,7.93-11.53Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M977.28,390.54l-6,89.09-.63,9.44-26.55-1.59-1-.06-20-1.2,1.35-47.62,5.39-24,13.33-34.89,7.93-11.53,9.44-13.63,2.52-3.54s1.67,10.18,7.81,5.69l.13-.09h0C977,352.81,977.28,390.54,977.28,390.54Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#1d2366"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M930.51,406.26s-2.39,5-7.19,4.19-4.79,18-4.79,18-3.19,3-5.39.4-8,6.19-8,6.19l-36.34,1.6s16.17,7.39,13,29.75c0,0,54.9-3.4,56.7-8.59S930.51,406.26,930.51,406.26Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M930.51,406.26s-2.39,5-7.19,4.19-4.79,18-4.79,18-3.19,3-5.39.4-8,6.19-8,6.19l-36.34,1.6s16.17,7.39,13,29.75c0,0,54.9-3.4,56.7-8.59S930.51,406.26,930.51,406.26Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.03
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "777.66 389.76 787.24 397.94 866.1 414.51 856.32 404.53 777.66 389.76",
    fill: "#fff"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M960.66,357.15c-1.31,2-5.06,12.24-8.19,21.18-2.61,7.45-4.79,14-4.79,14s-5.09,33.14-7.69,39.13-1.19,29.35-1.19,29.35l-9.69,57.69s-4.39,29.75-11.17,47.52c-6.69,17.49-14.14,25.69-14.37,25.95,3-4.06,19.35-84,19.35-84l5.4-100.82s.79-9.58,1.59-17.77,17-19.37,17-19.37l15.62-22.21C964.1,349.9,963.05,353.56,960.66,357.15Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M919.93,486.72s-23-1-34.14-14.38S911.54,467,911.54,467l9.59,2.2Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#ffb0b1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.34,639.85a29.14,29.14,0,0,0-.58,13.39c-25.09,1.78-51.93-5-51.93-5-5,4.6-18.17,11.38-18.17,11.38l-7.18-89c-4.59-12-6.39-74.87-6.39-74.87s.41-3.29,1-8.22c0-.12,0-.25.05-.37,1.79-13.77,5.34-39.62,7.08-43.11,2.4-4.8-7.38-17.57-7.38-17.57l4.45-37.95.54-4.58c9.38-4.19,16.57-17.57,16.57-17.57l5.52-9.67h0c6-3.85,6.31,33.88,6.31,33.88l-6,89.09,19.88-5.49S1030.73,628.47,1027.34,639.85Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.09,646c-27.35,13.58-77.06,1-77.06,1-5,4.6-18.17,11.38-18.17,11.38l-7.19-89c-4.58-12-6.38-74.87-6.38-74.87s5.78-46.91,8.18-51.7c.7-1.4.36-3.48-.47-5.72a72.38,72.38,0,0,1-4.38-33.49l1.92-16.31.53-4.57c9.39-4.2,16.58-17.58,16.58-17.58l5-8.76,9.2-16.14,4.36-7.64.74.67,5.65,5.12s2.4,2,6,5c7.83,6.6,21.36,18.22,28.34,25.33,6.14,6.26,8.08,30.61,8.64,48.94.37,12.07.15,21.53.15,21.53-6.19,10.19,10,92,10,92C1048.5,547,1053.09,646,1053.09,646Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.59,364.94S981.82,400.67,984,414.25s8.38,28.95,5.39,32.54a11.05,11.05,0,0,1-8.79,4.39c-3,.2-11,5.79-11,6.39s-7.39.6-14,3.4-16.37,4.39-16.37,4.39-19-.6-20.77,1.2-3.59,12.57.2,21.16,8,15,11.18,16.17,23.36-5.59,39.73-7.19,34.14-14.57,34.14-14.57,19.57-7,23-18.77-4.19-76.46-4.19-76.46S1016.76,356.75,1000.59,364.94Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.03
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M998.19,361.94s-18.77,35.74-16.57,49.31S990,440.2,987,443.8a11,11,0,0,1-8.78,4.39c-3,.2-11,5.79-11,6.39s-7.39.6-14,3.39-16.37,4.39-16.37,4.39-19-.6-20.76,1.2-3.6,12.58.2,21.16,8,15,11.18,16.17,23.36-5.59,39.73-7.18,34.14-14.58,34.14-14.58,19.56-7,22.95-18.76-4.19-76.47-4.19-76.47S1014.36,353.76,998.19,361.94Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.03
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1000,363.14s-18.77,35.74-16.57,49.31,8.38,28.95,5.39,32.54a11,11,0,0,1-8.79,4.4c-3,.2-11,5.79-11,6.38s-7.38.6-14,3.4-16.37,4.39-16.37,4.39-19-.6-20.77,1.2-3.59,12.58.2,21.16,8,15,11.18,16.17,23.36-5.59,39.73-7.19,34.14-14.57,34.14-14.57,19.57-7,23-18.77S1022,385.1,1022,385.1,1016.16,355,1000,363.14Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M999.59,459s-15-3-9.78,2,5.19,9.38,11.58,9.18S999.59,459,999.59,459Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.94,566.58s-6.78,4.59,6.19,15.17S1024.94,566.58,1024.94,566.58Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1012,604.31c0,.6-2.4,22,6.58,27.35S1012,604.31,1012,604.31Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M869.42,436.59c-7.24.25-22.88,2.46-14.77,17.59,7.17,13.39,19.22,4.44,26-2.35A25.55,25.55,0,0,0,869.42,436.59Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#ffb0b1"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M881.39,451v0Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#ffb0b1"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M880.74,451.71l.3-.31Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#ffb0b1"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M997.6,344c-7.68,5.25-14.12,9.68-15.38,10.6-3.44,2.55-10,17.52-14.23,25.16-3.37,6.15-14.32,7.73-18.45,8.12l.53-4.57c9.39-4.2,16.58-17.58,16.58-17.58l18.56-32.54L991.6,339S994,341,997.6,344Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M997.6,343.4c-7.68,5.25-14.12,9.68-15.38,10.61-3.44,2.54-10,17.51-14.23,25.15-3.37,6.15-14.32,7.73-18.45,8.12l.53-4.57c9.39-4.2,16.58-17.58,16.58-17.58l18.56-32.54,6.39,5.79S994,340.36,997.6,343.4Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#dce7ff"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M982.82,317.92a29.61,29.61,0,0,1-5.22,16.81,29.66,29.66,0,1,1,5.22-16.81Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#ffb0b1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.58,417.67a26.36,26.36,0,0,1-9.57-10.28c-1.67-3.3-2.78-7.11-5.63-9.45-2.57-2.1-6-2.61-9.2-3.55-10.52-3.11-19.34-12.71-19.67-23.67-.16-5.16,1.45-10.31.72-15.42a17.08,17.08,0,0,0-3.34-7.95,27.37,27.37,0,0,0-2.89-3.11c-1.4-1.32-2.87-2.6-4.15-4a15.53,15.53,0,0,1-2.1-2.85,13.71,13.71,0,0,1-1.15-2.65c-2-6.12-.18-13.38-2.38-19.57l-.12-.34c-.83-2.2-2.52-4.4-4.87-4.57s-4.36,1.78-6.6,2.65c-4.69,1.82-9.75-1.28-13.66-4.44s-8.32-6.77-13.29-6.07c-3.29.47-5.89,2.71-8.92,3.87a12.5,12.5,0,0,1-2.11.61,29.65,29.65,0,0,1,57.17,11.05,29.35,29.35,0,0,1-.65,6.19c.05.14.1.27.16.41,1.16,3,2.47,6.08,3.62,8.74l5.65,5.12s2.4,2,6,5c7.83,6.6,21.36,18.22,28.34,25.33C1032.08,375,1034,399.34,1034.58,417.67Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M927.41,288c1.43-2.91,2.14-6.17,3.85-8.93,2.51-4,6.89-6.56,11.39-8.11,11.75-4.05,36.58-9.93,44,0,1.46,2,2.67,4.22,4.69,5.6,1.54,1.05,3.4,1.5,5.09,2.29,4.73,2.22,7.75,7.06,9.36,12s2.09,10.24,3.27,15.33c1.51,6.53,4.16,12.72,6.8,18.87,3.11,7.26,6.41,14.79,12.41,19.92,8.19,7,10,16.91,17.6,24.59,9,9.12,8.71,24.17,4.07,36.12-.61,1.57-1.3,3.21-1.06,4.88s1.48,3.19,2.65,4.52l4.92,5.55c-11.64,2.81-24.81-3.27-30.23-13.94-1.67-3.3-2.78-7.1-5.64-9.45-2.56-2.1-6-2.6-9.19-3.54-10.52-3.12-19.34-12.73-19.67-23.69-.16-5.15,1.45-10.3.72-15.4a17,17,0,0,0-3.35-8c-2.75-3.59-6.9-6-9.14-10-3.79-6.69-.91-15.38-3.64-22.56-.84-2.2-2.52-4.4-4.87-4.57s-4.36,1.78-6.61,2.65c-4.68,1.82-9.74-1.27-13.65-4.44s-8.32-6.77-13.3-6.06c-3.29.46-5.88,2.7-8.91,3.87-2.24.86-6.78,1.63-8.74-.26C916.09,301.43,925.68,291.56,927.41,288Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#591d4b"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1029,403.39c-1.68-3.3-2.78-7.1-5.64-9.44-2.56-2.1-6-2.61-9.2-3.55-10.51-3.11-19.33-12.72-19.67-23.68-.16-5.15,1.45-10.31.73-15.41a17.1,17.1,0,0,0-3.35-7.95c-2.76-3.59-6.91-6-9.14-10-3.79-6.68-.91-15.37-3.65-22.56-.83-2.19-2.52-4.39-4.86-4.57s-4.37,1.79-6.61,2.66c-4.68,1.82-9.75-1.28-13.65-4.44s-8.33-6.77-13.3-6.07c-3.29.47-5.89,2.71-8.91,3.87-2.24.86-6.79,1.64-8.75-.25-4.12-4,5.47-13.85,7.19-17.39,1.43-2.92,2.14-6.17,3.86-8.93.09-.15.19-.3.29-.45a15.88,15.88,0,0,0-3.29,3.74c-1.71,2.76-2.42,6-3.85,8.93-1.73,3.54-11.32,13.42-7.19,17.39,2,1.9,6.5,1.12,8.74.26,3-1.17,5.62-3.41,8.91-3.87,5-.71,9.4,2.9,13.3,6.06s9,6.26,13.66,4.44c2.24-.87,4.2-2.83,6.6-2.65s4,2.37,4.87,4.57c2.73,7.18-.15,15.87,3.64,22.56,2.24,3.93,6.39,6.39,9.14,10a17,17,0,0,1,3.35,8c.73,5.1-.88,10.25-.72,15.4.33,11,9.15,20.57,19.67,23.69,3.17.94,6.63,1.44,9.19,3.54,2.87,2.35,4,6.15,5.64,9.45,5.42,10.67,18.59,16.75,30.23,13.94l-2.32-2.62C1043.82,418.21,1033.61,412.47,1029,403.39Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M960.06,357.75c-1.31,2-5.06,12.24-8.19,21.18-2.93-1.14-5.59-8.41-5.59-8.41L961.9,348.3C963.5,350.5,962.45,354.15,960.06,357.75Z",
    transform: "translate(-47.24 -58.63)",
    opacity: 0.1
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M960.66,357.15c-1.31,2-5.06,12.24-8.19,21.18-2.93-1.13-5.59-8.41-5.59-8.41l15.62-22.21C964.1,349.9,963.05,353.56,960.66,357.15Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#dce7ff"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M869.84,459.31,861.18,432a2.55,2.55,0,0,1,1.66-3.21h0a2.56,2.56,0,0,1,3.2,1.66l8.66,27.28-.86,5.71Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#be8b87"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M862,429.6h0a2.56,2.56,0,0,1,3.21,1.66l8.66,27.28-.65,4.28.63.66.86-5.71L866,430.49a2.56,2.56,0,0,0-3.2-1.66h0a2.56,2.56,0,0,0-1.33,1A3.48,3.48,0,0,1,862,429.6Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#fff",
    opacity: 0.1
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "822.6 400.68 827.46 399.14 826.75 403.82 826.6 404.85 825.18 403.37 822.6 400.68",
    fill: "#efc8c4"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M872.42,462a1,1,0,0,1,.31-.26.44.44,0,0,1,.47,0,1.24,1.24,0,0,1,.17.27.86.86,0,0,0,.62.41l-.15,1Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#727a9c"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M861.13,441.7s17.37-.1,13.28,7.29-10.48,8.28-10.48,8.28Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#ffb0b1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M753.1,110.05h-.75c-29.84,0-56.23,15.79-71.41,39.09-15.18-23.3-41.57-39.09-71.41-39.09h-.75A85,85,0,0,0,524.59,195c0,27.81,12.18,67.27,35.93,99.74,45.25,61.87,120.42,116,120.42,116s75.17-54.12,120.41-116c23.76-32.47,35.93-71.93,35.93-99.74A85,85,0,0,0,753.1,110.05ZM742.37,299.5a16.85,16.85,0,0,1-15.67-10.82H708.86a5.64,5.64,0,0,1-5.31-3.84l-5.48-16.51-17.34,60.59a5.61,5.61,0,0,1-5.38,4.05H675a5.54,5.54,0,0,1-5.2-4.64L651.93,220.85l-13.06,63.6a5.57,5.57,0,0,1-5.41,4.23H608.33a5.59,5.59,0,1,1,0-11.17h20.73L647.56,192a5.61,5.61,0,0,1,11,.46l18.25,109.64,15.54-54.21a5.5,5.5,0,0,1,5.23-4h.11a5.58,5.58,0,0,1,5.3,3.84l9.91,29.81h13.58a16.76,16.76,0,1,1,15.92,22Z",
    transform: "translate(-47.24 -58.63)",
    fill: "#2696be"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/medicine.b2e139e5ebc170142e98d2d3b1139577.svg";
export { ForwardRef as ReactComponent };